import axios from 'axios';
import config from '../../config.js'

const instance = axios.create({
	baseURL: config.baseURL + '/api/',
	timeout: 100000
});

export function addResponseHandler(success, error){
    instance.interceptors.response.use(success, error);
}

export default instance;
